var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('d-container',{staticClass:"main-content-container px-4",attrs:{"fluid":""}},[(!_vm.userIsCustomer)?_c('dashboard'):_vm._e(),(_vm.userIsCustomer)?_c('welcome'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }